<template>
  <div :class="`chart learners-engagement md-layout-item md-size-${width} md-medium-size-${width} md-small-size-100`">
    <div>
      <h2>{{label}}</h2>
      <div>
        <apexchart type=bar height=320 :options="chartOptions" :series="series" />
      </div>
      <div class="spacer">&nbsp;</div>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'

  export default {
    name: "LearnersEngagementStrategy",
    computed: {},
    components: {
      apexchart: VueApexCharts
    },

    data() {
      let data = window.drupalSettings.controller.graphs.LearnersEngagementStrategy.data;
      let series = [];


      series.push({
        name: 'Strategies viewed',
        data: data.map((item) => {
          return item.count_activities;
        })
      });
      series.push({
        name: 'Strategies badged',
        data: data.map((item) => {
          return item.count_completed;
        })
      });

      let learners = data.map((item) => {
        return item.firstname + ' ' + item.lastname;
      });
      return {
        label: window.drupalSettings.controller.graphs.LearnersEngagementStrategy.label,
        width: window.drupalSettings.controller.graphs.LearnersEngagementStrategy.width || 33,
        series: series,
        chartOptions: {
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: ['#457b9d', '#b0d7b9'],
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                position: 'top',
              },
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },

          legend: {
            fontSize: "14px",
            fontFamily: 'Source Sans Pro',
            offsetY: -5,
            labels: {
              colors: ['#3c3c3c'],
            },
          },
          xaxis: {
            categories: learners,
            labels: {
              style: {
                colors: ['#3c3c3c'],
                fontSize: '14px',
                fontFamily: 'Source Sans Pro',
              }
            },
            axisBorder: {
              show: true,
              color: '#cccccc',
            },
            axisTicks: {
              show: true,
              color: '#3c3c3c'
            },
          },
          yaxis: {
            title: {
              text: '',
              style: {
                color: '#3c3c3c',
                fontSize: '14px',
                fontFamily: 'Source Sans Pro',
              }
            },
            labels: {
              style: {
                color: '#3c3c3c',
                fontSize: "16px",
                fontFamily: 'Source Sans Pro'
              },
              formatter: function(val) {
                return val.toFixed(0)
              }
            },
            floating: false,
          },
          // fill: {
          //   type: 'gradient',
          //   gradient: {
          //     shade: 'dark',
          //     type: "vertical",
          //     shadeIntensity: 0.5,
          //     gradientToColors: ['#3D9AB9', '#FEA104'], // optional, if not defined - uses the shades of same color in series
          //     inverseColors: true,
          //     opacityFrom: 1,
          //     opacityTo: 1,
          //   }
          // },
          tooltip: {
            y: {
              formatter: function (val) {
                return val
              }
            }
          }
        }
      };
    },
  };
</script>
<style lang="scss" scoped>
</style>
